import { TapResponseFrame, TapRequestFrame } from '@iotize/tap/client/api';
import {
  HostProtocol,
  TargetProtocol,
  VariableFormat,
  AppPathType,
  SpecialFeature,
  TapVersion,
} from '@iotize/tap';

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum FirmwareState {
  LEGACY = 0,
  NORMAL = 1,
  UPDATING = 2,
  UPDATED = 4,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum FirmwareUpdateResult {
  DEFAULT_VALUE = 0,
  UPDATE_SUCCESSFUL = 1,
  NOT_ENOUGH_MEMORY = 2,
  OUT_OF_MEMORY = 4,
  CONNECTION_LOST = 8,
  CRC_CHECK_FAILURE = 16,
  UNSUPPORTED_PACKAGE_TYPE = 32,
  INVALID_URI = 64,
}

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface CrcCheckBody {
  address: number;
  size: number;
  crc: number;
}
